export const LOCATION_FULLNAME_MAPPING: any = {
  NAKHON_PATHOM: "โรงงานนครปฐม",
  SRIRACHA: "โรงงานศรีราชา",
  NAKHON_LUANG: "โรงงานนครหลวง",
};

export const LOCATION_DATA = [
  { key: 1, LocationName: "NAKHON_PATHOM", LocationNameTH: "โรงงานนครปฐม", company: "ICPL" },
  { key: 2, LocationName: "SRIRACHA", LocationNameTH: "โรงงานศรีราชา", company: "ICPI" },
  { key: 3, LocationName: "NAKHON_LUANG", LocationNameTH: "โรงงานนครหลวง", company: "ICPI" },
  { key: 4, LocationName: "NAKHON_LUANG", LocationNameTH: "โรงงานนครหลวง", company: "ICPF" },
];
